import { useInjection } from 'libs/uikit/ioc/React';
import { useAsync } from 'libs/uikit/lib';
import { IAuthenticationStore } from '../../core/Abstractions/IAuthenticationStore';
import { logout } from './LogoutButton';

/**
 * LogoutPage just calls the logout function and renders nothing.
 * The angularjs pages redirect users here to logout.
 * React pages can call logout() directly instead.
 */
export function LogoutPage() {
  const authenticationStore = useInjection(IAuthenticationStore);

  useAsync(async () => {
    await logout(authenticationStore);
  });

  return null;
}
